import React, { useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import * as S from "./styles";
import ModalParams from "components/ModalEditParams";

import { DownloadButton } from "components/Buttons/ActionButton";
import { getBeneficiaryType, convertDateFromApi, scrollToTop } from "utils";
import { parameters } from "utils/constants";
import { useApi } from "hooks/useApis";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import AgentType from "utils/agentType";
import { useSelector } from 'react-redux';
import SuccessAlert from "components/Alerts/SuccessAlert";
import FillErrorAlert from "components/Alerts/FillErrorAlert";
import { serverErrorMsg } from "utils/constants";

const TableParams = () => {
  const api = useApi();

  const [openModal, setOpenModal] = useState(false);

  const [valuesParams, setValuesParams] = useState({});

  const [idParam, setIdParam] = useState(0);
  
  const [alertType, setAlertType] = useState('');

  const [alertMessage, setAlertMessage] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  
  const agentType = AgentType();
  
  const isManager = ['1'].includes(agentType);

  const widthTable = isManager ? '35%' : '40%'

  const user = useSelector((state) => state.user?.user);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.getParams();
        setValuesParams([
          response.income_per_capta,
          response.days_after_birth_without_registration,
          response.general_limit,
          response.max_child_age,
        ]);
      } catch (err) {
        // setError(err);
        console.log(err);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, []);

  const onSubmitEditValue = async (data) => {
    try {
      setIsLoading(true)
      const attributeName = parameters[idParam].attributeName;

      const formatedData = {
        [attributeName]: data.valueParam,
        justification: data.justification
      };
      const response = await api.patchParams(formatedData);
      setOpenModal(false)
      setIsLoading(false)
      setAlertType('success')
      setAlertMessage('Valor do parâmetro editado com sucesso!')
    } catch (err) {
      setAlertType('error')
      setAlertMessage(err?.status === 500 ? serverErrorMsg : err?.response?.data?.detail)
      setIsLoading(false)
      console.log(err);
    }
  };

  return (
    <>
      <S.TableContainer>
        <S.StyledTable>
          <S.StyledTableHead>
            <tr>
              <S.StyledTableHeaderCell style={{width: widthTable}}>Parâmetro</S.StyledTableHeaderCell>
              <S.StyledTableHeaderCell  style={{width: widthTable}}>Descrição</S.StyledTableHeaderCell>
              <S.StyledTableHeaderCell  style={{width: widthTable}}>Valor</S.StyledTableHeaderCell>
              {isManager && 
              <S.StyledTableHeaderCell >Ação</S.StyledTableHeaderCell>}
            </tr>
          </S.StyledTableHead>
          <S.StyledTableBody>
            {parameters?.map((row) => {
              return (
                <S.StyledTableRow key={row.id}>
                  <S.StyledTableCell>{row.param}</S.StyledTableCell>
                  <S.StyledTableCell>{row.description}</S.StyledTableCell>
                  <S.StyledTableCell>
                    {valuesParams[row.id] &&
                      [0].includes(row.id) &&
                      Number(valuesParams[row.id]).toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    {[2].includes(row.id) && Number(valuesParams[row.id]).toLocaleString("pt-BR")}
                    {[1, 3].includes(row.id) && valuesParams[row.id]}
                  </S.StyledTableCell>
                  <S.StyledTableCell>
                    <S.ButtonsContainer>
                      {isManager && (
                        <Tooltip title="Alterar valor">
                          <div
                            onClick={() => {
                              setOpenModal(true);
                              setIdParam(row.id);
                            }}
                          >
                            <DownloadButton />
                          </div>
                        </Tooltip>
                      )}
                    </S.ButtonsContainer>
                  </S.StyledTableCell>
                </S.StyledTableRow>
              );
            })}
          </S.StyledTableBody>
        </S.StyledTable>
      </S.TableContainer>
      <ModalParams
        open={openModal}
        handleClose={() => setOpenModal(false)}
        onSubmit={onSubmitEditValue}
        isLoading={isLoading}
      />
      <SuccessAlert
        open={alertType === "success"}
        onClose={() => {setAlertType(""); window.location.reload()}}
        alertText={alertMessage}
      />
      <FillErrorAlert
        open={alertType === "error"}
        onClose={() => setAlertType("")}
        message={alertMessage}
      />
    </>
  );
};

export default TableParams;
